import { api } from '../utils/apiClient'
import { API_CONFIG } from '../config/constants'

const ADMIN_BASE = '/api/admin'

// Build query string from params; omit undefined/null/empty so we never send e.g. search=undefined
function toQueryString(params) {
  const cleaned = {}
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== null && (typeof value !== 'string' || value.trim() !== '')) {
      cleaned[key] = value
    }
  }
  const qs = new URLSearchParams(cleaned).toString()
  return qs ? `?${qs}` : ''
}

export const adminService = {
  // Login
  login: async (username, password) => {
    return await api.post(`${ADMIN_BASE}/login`, { username, password })
  },

  // Get Dashboard Stats
  getStats: async () => {
    return await api.get(`${ADMIN_BASE}/stats`)
  },

  // Get Submissions
  getSubmissions: async (params = {}) => {
    return await api.get(`${ADMIN_BASE}/submissions${toQueryString(params)}`)
  },

  // Get Single Submission
  getSubmission: async (id) => {
    return await api.get(`${ADMIN_BASE}/submissions/${id}`)
  },

  // Update Submission Status
  updateSubmissionStatus: async (id, status, adminNotes) => {
    return await api.patch(`${ADMIN_BASE}/submissions/${id}/status`, {
      status,
      adminNotes,
    })
  },

  // Update Submission Notes
  updateSubmissionNotes: async (id, adminNotes) => {
    return await api.patch(`${ADMIN_BASE}/submissions/${id}/notes`, {
      adminNotes,
    })
  },

  // Get Orders
  getOrders: async (params = {}) => {
    return await api.get(`${ADMIN_BASE}/orders${toQueryString(params)}`)
  },

  // Get Single Order
  getOrder: async (id) => {
    return await api.get(`${ADMIN_BASE}/orders/${id}`)
  },

  // Change password
  changePassword: async (currentPassword, newPassword) => {
    return await api.patch(`${ADMIN_BASE}/me/password`, { currentPassword, newPassword })
  },

  // Export Submissions to CSV
  exportSubmissions: async (params = {}) => {
    const queryString = toQueryString(params).replace(/^\?/, '')
    const fetchUrl = queryString ? `${API_CONFIG.BASE_URL}${ADMIN_BASE}/submissions/export?${queryString}` : `${API_CONFIG.BASE_URL}${ADMIN_BASE}/submissions/export`
    const response = await fetch(fetchUrl, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('adminToken')}`,
      },
    })
    if (!response.ok) throw new Error('Export failed')
    const blob = await response.blob()
    const blobUrl = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = blobUrl
    a.download = `submissions-${new Date().toISOString().split('T')[0]}.csv`
    document.body.appendChild(a)
    a.click()
    window.URL.revokeObjectURL(blobUrl)
    document.body.removeChild(a)
    return { success: true }
  },

  // Export Orders to CSV
  exportOrders: async (params = {}) => {
    const queryString = toQueryString(params).replace(/^\?/, '')
    const fetchUrl = queryString ? `${API_CONFIG.BASE_URL}${ADMIN_BASE}/orders/export?${queryString}` : `${API_CONFIG.BASE_URL}${ADMIN_BASE}/orders/export`
    const response = await fetch(fetchUrl, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('adminToken')}`,
      },
    })
    if (!response.ok) throw new Error('Export failed')
    const blob = await response.blob()
    const blobUrl = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = blobUrl
    a.download = `orders-${new Date().toISOString().split('T')[0]}.csv`
    document.body.appendChild(a)
    a.click()
    window.URL.revokeObjectURL(blobUrl)
    document.body.removeChild(a)
    return { success: true }
  },
}
